<div id="tf-login" fxLayout="column">
    <div class="custom-top-nav py-2">
        <img class="page-giant-logo border-1 mx-3" width="140" src="../../../../assets/images/logo/giant2.png">
    </div>
    <div class="company-info py-2 text-center"><h5 class="m-0">Enter Verification Code</h5></div>
    <div id="tf-login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="tf-login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <!-- <div class="logo">
                <img src="../../../../assets/images/logo/giant2.png">
            </div>
          
            <div class="title">Enter Verification Code</div> -->
          
            <form name="tfLoginForm" #tftLoginForm="ngForm">
             <mat-form-field appearance="outline">
             <!-- <mat-label style="font-weight: bold;">Please enter your verification code</mat-label> -->
            
             <input matInput  type="text"  style="font-weight: bold;" pattern="number" [(ngModel)]="userModel.verificationcode" #email="ngModel" name="email"  placeholder="Please enter your verification code">
             </mat-form-field>  
           <div class="row" style="display: flex;">
             
                <button mat-raised-button  class="submit-button " aria-label="Submit" (click)="UpdateClientAuthenticationCode()" style="background-color: #36639f; color: #fff;; cursor: pointer; width: 45%; margin-bottom: 5px; margin-right: 10px; margin-top: 0;">
                    Submit
                </button>
                <button mat-raised-button  class="submit-button" aria-label="Submit" (click)="SendAuthenticationCode()" style="background-color: #36639f; color: #fff;; cursor: pointer; width: 45%; margin-bottom: 5px; margin-top: 0;" >
                    Resend
                </button>
              
              </div>
            
            </form>
        </div>
    </div>
</div>
